'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        xAxisAxisCrossingValue: {
            type: [Object, Date, Array, String, Number],
            default: undefined,
            kComposite: 'xAxis.axisCrossingValue'
        },
        xAxisBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.background'
        },
        xAxisBaseUnit: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.baseUnit'
        },
        xAxisColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.color'
        },
        xAxisCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.color'
        },
        xAxisCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.opacity'
        },
        xAxisCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.background'
        },
        xAxisCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.border.color'
        },
        xAxisCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.border.dashType'
        },
        xAxisCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.border.width'
        },
        xAxisCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.color'
        },
        xAxisCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.font'
        },
        xAxisCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.format'
        },
        xAxisCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.padding'
        },
        xAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.padding.bottom'
        },
        xAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.padding.left'
        },
        xAxisCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.padding.right'
        },
        xAxisCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.padding.top'
        },
        xAxisCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.template'
        },
        xAxisCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.visible'
        },
        xAxisCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.crosshair.visible'
        },
        xAxisCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.width'
        },
        xAxisLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.background'
        },
        xAxisLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.border.color'
        },
        xAxisLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.border.dashType'
        },
        xAxisLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.border.width'
        },
        xAxisLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.color'
        },
        xAxisLabelsCulture: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.culture'
        },
        xAxisLabelsDateFormatsDays: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.dateFormats.days'
        },
        xAxisLabelsDateFormatsHours: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.dateFormats.hours'
        },
        xAxisLabelsDateFormatsMonths: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.dateFormats.months'
        },
        xAxisLabelsDateFormatsWeeks: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.dateFormats.weeks'
        },
        xAxisLabelsDateFormatsYears: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.dateFormats.years'
        },
        xAxisLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.font'
        },
        xAxisLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.format'
        },
        xAxisLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.margin'
        },
        xAxisLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.margin.bottom'
        },
        xAxisLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.margin.left'
        },
        xAxisLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.margin.right'
        },
        xAxisLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.margin.top'
        },
        xAxisLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.labels.mirror'
        },
        xAxisLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.padding'
        },
        xAxisLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.padding.bottom'
        },
        xAxisLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.padding.left'
        },
        xAxisLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.padding.right'
        },
        xAxisLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.padding.top'
        },
        xAxisLabelsRotation: {
            type: [Number, String],
            default: undefined,
            kComposite: 'xAxis.labels.rotation'
        },
        xAxisLabelsRotationAlign: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.rotation.align'
        },
        xAxisLabelsRotationAngle: {
            type: [Number, String],
            default: undefined,
            kComposite: 'xAxis.labels.rotation.angle'
        },
        xAxisLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.skip'
        },
        xAxisLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.step'
        },
        xAxisLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'xAxis.labels.template'
        },
        xAxisLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.labels.visible'
        },
        xAxisLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'xAxis.labels.visual'
        },
        xAxisLineColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.line.color'
        },
        xAxisLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.line.dashType'
        },
        xAxisLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.line.visible'
        },
        xAxisLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.line.width'
        },
        xAxisMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.color'
        },
        xAxisMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.dashType'
        },
        xAxisMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.visible'
        },
        xAxisMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.width'
        },
        xAxisMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.step'
        },
        xAxisMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.skip'
        },
        xAxisMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.color'
        },
        xAxisMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.dashType'
        },
        xAxisMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.visible'
        },
        xAxisMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.width'
        },
        xAxisMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.step'
        },
        xAxisMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.skip'
        },
        xAxisMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.minorTicks.color'
        },
        xAxisMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorTicks.size'
        },
        xAxisMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.minorTicks.visible'
        },
        xAxisMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorTicks.width'
        },
        xAxisMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorTicks.step'
        },
        xAxisMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorTicks.skip'
        },
        xAxisMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.majorTicks.color'
        },
        xAxisMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorTicks.size'
        },
        xAxisMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.majorTicks.visible'
        },
        xAxisMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorTicks.width'
        },
        xAxisMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorTicks.step'
        },
        xAxisMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorTicks.skip'
        },
        xAxisMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorUnit'
        },
        xAxisMax: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.max'
        },
        xAxisMin: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.min'
        },
        xAxisMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorUnit'
        },
        xAxisName: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.name'
        },
        xAxisNarrowRange: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.narrowRange'
        },
        xAxisPane: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.pane'
        },
        xAxisPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'xAxis.plotBands'
        },
        xAxisReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.reverse'
        },
        xAxisStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.startAngle'
        },
        xAxisTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.background'
        },
        xAxisTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.border.color'
        },
        xAxisTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.border.dashType'
        },
        xAxisTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.border.width'
        },
        xAxisTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.color'
        },
        xAxisTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.font'
        },
        xAxisTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.margin'
        },
        xAxisTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.margin.bottom'
        },
        xAxisTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.margin.left'
        },
        xAxisTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.margin.right'
        },
        xAxisTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.margin.top'
        },
        xAxisTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.padding'
        },
        xAxisTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.padding.bottom'
        },
        xAxisTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.padding.left'
        },
        xAxisTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.padding.right'
        },
        xAxisTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.padding.top'
        },
        xAxisTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.position'
        },
        xAxisTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.rotation'
        },
        xAxisTitleText: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.text'
        },
        xAxisTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.title.visible'
        },
        xAxisTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'xAxis.title.visual'
        },
        xAxisType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.type'
        },
        xAxisVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.visible'
        },
        xAxisNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.position'
        },
        xAxisNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.icon.background'
        },
        xAxisNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.icon.border.color'
        },
        xAxisNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.icon.border.width'
        },
        xAxisNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.icon.size'
        },
        xAxisNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.icon.type'
        },
        xAxisNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.notes.icon.visible'
        },
        xAxisNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.background'
        },
        xAxisNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.border.color'
        },
        xAxisNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.border.dashType'
        },
        xAxisNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.label.border.width'
        },
        xAxisNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.color'
        },
        xAxisNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.font'
        },
        xAxisNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'xAxis.notes.label.template'
        },
        xAxisNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.notes.label.visible'
        },
        xAxisNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.label.rotation'
        },
        xAxisNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.format'
        },
        xAxisNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.position'
        },
        xAxisNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.line.dashType'
        },
        xAxisNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.line.width'
        },
        xAxisNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.line.color'
        },
        xAxisNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.line.length'
        },
        xAxisNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'xAxis.notes.data'
        }, xAxisNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'xAxis.notes.visual'
        }
    }
};